import { Cancel } from '@mui/icons-material';
import { Box, Card, CardMedia, IconButton } from '@mui/material';

import { AddImageIcon } from '~assets/icons';
import { CenterStack } from '~components/atoms/custom';
import { CircularWithValueLabel } from '~components/atoms/photo-upload';
import { CameraComponent } from '~components/organisms/camera';
import { useCameraContext } from '~providers/CameraProvider';

const svgBackground = `
  url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23009EFA' stroke-width='2' stroke-dasharray='3%2c 5' stroke-dashoffset='32' stroke-linecap='square'/%3e%3c/svg%3e")
`;

export const ZonePlaceHolder = ({ children }: React.PropsWithChildren) => (
  <Box
    width={'100%'}
    height={'100%'}
    sx={{
      backgroundColor: '#F7F9FB',
      backgroundImage: svgBackground,
      borderRadius: '8px',
    }}
  >
    {children}
  </Box>
);

export const ZonePhotoUpload: React.FC = () => {
  const {
    openCamera,
    uploadedFile,
    loadingState,
    onRemoveFile,
    onOpenPreviewView,
  } = useCameraContext();

  return (
    <CenterStack height={130} width={'100%'} sx={{ borderRadius: '8px' }}>
      {uploadedFile?.url && loadingState === 'END' ? (
        <Card
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '8px',
            position: 'relative',
            overflow: 'unset',
          }}
        >
          <CardMedia
            onClick={() => onOpenPreviewView(uploadedFile?.url || '')}
            sx={{ height: '100%', borderRadius: '8px' }}
            image={uploadedFile.url}
            title={uploadedFile.name}
          />
          <IconButton
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translate(55%, -55%)',
            }}
            color={'primary'}
            onClick={onRemoveFile}
          >
            <Cancel sx={{ color: 'text.charcoal' }} />
          </IconButton>
        </Card>
      ) : (
        <ZonePlaceHolder>
          <CenterStack width={'100%'} height={'100%'} gap={1.5}>
            {loadingState !== 'END' ? (
              <CircularWithValueLabel loadingState={loadingState as string} />
            ) : (
              <IconButton onClick={openCamera}>
                <AddImageIcon />
              </IconButton>
            )}
          </CenterStack>
        </ZonePlaceHolder>
      )}
      <CameraComponent />
    </CenterStack>
  );
};
